import withWatchlist from 'src/components/filmwebid/withWatchlist';
import withWatchlistState from 'src/components/filmwebid/withWatchlistState';
import FilmwebLink from 'src/components/filmweblink/FilmwebLink';
import WatchlistActionButton from 'src/components/kommendefilmer/WatchlistActionButton';
import Poster, { type PosterProps } from 'src/components/posterrow/Poster';
import { format, parseISO } from "date-fns";
import locale from "date-fns/locale/nb";
import { useLocationContext } from 'src/lib/contexts/LocationContext';
import { Movie } from 'src/lib/movieinfo/movieinfotypes';
import styled from 'src/lib/styles/css';

//#region [Props]
type KommerPosterProps = {
	dateFormat: "thisweek" | "thisyear" | "year";
} & PosterProps;
//#endregion

//#region [Component]
export default function KommerPoster(props: KommerPosterProps) {
	const locContext = useLocationContext();
	const movie = props.film as Movie;
	if (!movie.premiere) {
		return null;
	}
	const premDate = parseISO(movie.premiere);
	let dateLabel: string;
	if (movie.isPremiereConfirmed) {
		switch (props.dateFormat) {
			case "thisweek":
				dateLabel = format(premDate, "EEEE dd.MM.", { locale });
				break;
			case "thisyear":
				dateLabel = format(premDate, "dd.MM.", { locale });
				break;
			case "year":
				dateLabel = format(premDate, "dd.MM.yyyy", { locale });
				break;
		}
	} else {
		dateLabel = format(premDate, "MMMM yyyy", {locale});
	}

	return <SWLPoster posterMissingText='Plakat kommer' showMovieTitleIfPosterIsMissing {...props}>
		<SPremActions>
			<SPremiere>{dateLabel}</SPremiere>
			{(locContext.location && movie.showsCount > 0) || movie.showsCount > 10 ? (
				<STicketButton to={`/film/${movie.mainVersionId}`}>Kjøp billetter</STicketButton>
			) : (
				<WLSWatchlistButton edi={movie.mainVersionId} />
			)}
		</SPremActions>
	</SWLPoster>;
}
//#endregion

const WLPoster = withWatchlist(Poster, "film");
const WLSWatchlistButton = withWatchlistState(WatchlistActionButton);

//#region [Styles]
const SPremActions = styled.div`
	border-radius: 0 0 8px 8px;
	margin: 0 4px 8px 4px;
`;

const SWLPoster = styled(WLPoster)`
	overflow: hidden;
	background-color: var(--buttoncolor);
	border-radius: 8px;

	div:first-child {
		border-radius: 0;
		* {
			border-radius: 0;
		}
	}

	h1 {
		padding: 8px 8px 0 8px;
		font-weight: bold;
		font-size: var(--font-title-xxxs_size);
		line-height: 15px; /* fallback */
		@media (max-width: 549px) {
			white-space: normal;
			height: 30px;
			box-sizing: content-box;
			a {

				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
			}
		}

		@media (min-width: 550px) {
			font-size: var(--font-title-xxs_size);
			line-height: 17px;
		}
	}
`;

const SPremiere = styled.div`
	font-size: var(--font-title-xxxs_size);
    text-transform: capitalize;
	font-weight: normal;
	line-height: 18px;
	margin-bottom: 5px;
	color: var(--textcolor);
	text-align: center;
	margin-top: 10px;
`;

const STicketButton = styled(FilmwebLink)`
	display: block;
	height: 25px;
	background-color: var(--textcolor);
	border: none;
	border-radius: 4px;
	width: 100%;
	color: var(--buttoncolor) !important;
	text-align: center;
	font-size: 12px;
	font-weight: 700;
	@media (min-width: 550px) {
        /*@media (orientation: landscape) {*/
        height: 28px;
        font-size: 13px;
    }
`;
//#endregion
